import request from '@/utils/request'

export const getProjectCost = id => request.get(`/accounting/projects/${id}/cost`)

export const getProjectAccounting = id => request.get(`/projects/${id}/accounting`)

export const updateProjectAccounting = (id, data) => request.put(`/projects/${id}/accounting`, data)
